import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";
import { Card } from "@/components/ranger/PageHeader";
import { Stars } from "@/components/ranger/Stars";
import { api, errMsg, fmtTime } from "@/lib/api";

export const ReviewsAdmin = ({ cid }) => {
  const [rows, setRows] = useState([]);
  const [denied, setDenied] = useState(false);
  const load = useCallback(() => api.get(`/communities/${cid}/reviews`).then((r) => setRows(r.data)).catch(() => setDenied(true)), [cid]);
  useEffect(() => { load(); }, [load]);
  const del = async (id) => { if (!window.confirm("Remove this review?")) return; try { await api.delete(`/communities/${cid}/reviews/${id}`); toast.success("Review removed"); load(); } catch (e) { toast.error(errMsg(e)); } };
  if (denied) return null;
  return (
    <Card title={`Player reviews (${rows.length})`} icon={Star} testId="reviews-admin-card">
      {rows.length === 0 ? <p className="text-sm text-slate-500">No reviews yet. Linked players rate with /review in Discord or on the player portal.</p> : (
        <ul className="max-h-80 divide-y divide-[#1E2D4A] overflow-y-auto">{rows.map((r) => (
          <li key={r.id} data-testid={`review-row-${r.id}`} className="flex items-start justify-between gap-3 py-2 text-sm">
            <div><div className="flex items-center gap-2"><span className="font-semibold text-slate-200">{r.gamertag}</span><Stars value={r.stars} size="h-3 w-3" /><span className="text-xs text-slate-500">{fmtTime(r.updated_at)}</span></div>
              {r.comment && <p className="mt-0.5 text-slate-400">{r.comment}</p>}</div>
            <button data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)} aria-label="Remove review" className="text-slate-500 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
          </li>))}</ul>)}
    </Card>
  );
};
